import React from "react"

import Layoutcs from "../../../components/layoutcs/layoutcs"
import SEO from "../../../components/seo"

import Container from "react-bootstrap/Container"

import Bloglist from "../../../components/bloglist/bloglist"

import "../../index.scss"
import "../../blog.scss"

import ImgBlogPost from "../../../images/blogpost/slovnicek-project-management.jpg"

const Blog = () => (
  <Layoutcs>
    <SEO
      title="Technický slovníček: Project management"
      description="Připravujeme pro vás Technický slovníček, abychom vám usnadnili porozumění procesu vývoje aplikací."
    />

    <Container className="ftrs-content pb-4 ftrs-blogpost">
      <h1 className="ftrs-h1">Technický slovníček: Project management</h1>

      <img
        className="ftrs-blogpost__img"
        src={ImgBlogPost}
        alt="Technický slovníček: Project management"
      />
    </Container>

    <div className="ftrs-blogpost__text">
      <Container>
        <p>
          Připravujeme pro vás Technický slovníček, abychom vám usnadnili
          porozumění procesu vývoje aplikací. Slovníček obsahuje vysvětlení
          nejčastěji používaných technických pojmů a&nbsp;pomáhá vám, kteří
          nemáte hlubší technické znalosti, s&nbsp;námi lépe spolupracovat
          a&nbsp;mít jasno v&nbsp;odborných termínech, se&nbsp;kterými často
          pracujeme. Pokud máte dotazy nebo návrhy na&nbsp;další termíny,
          neváhejte nás kontaktovat. Jsme tu pro&nbsp;vás a&nbsp;rádi vám
          poskytneme další informace.
        </p>
        <hr className="mt2 mb2" />

        <h2 className="ftrs-h2 mt2 mb1">Analýza a zadání projektu</h2>
        <p>
          Analýza a zadání projektu je klíčovým krokem při&nbsp;plánování
          a&nbsp;přípravě projektu. Během analýzy se pečlivě zkoumají požadavky
          a&nbsp;potřeby projektu, aby bylo možné jasně definovat jeho cíle,
          rozsah a&nbsp;omezení. Zadání projektu pak shrnuje výsledky analýzy
          a&nbsp;stanovuje směr a&nbsp;očekávání projektu. Tímto způsobem je
          vytvořen pevný základ pro&nbsp;efektivní řízení a&nbsp;plánování
          projektových aktivit.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Agile vs. waterfall</h2>
        <p>
          Agile a waterfall jsou dvě různé metody vývoje softwaru
          s&nbsp;odlišnými přístupy. Waterfall (vodopádový model) je sériový
          přístup, kde&nbsp;se práce provádí sekvenčně po&nbsp;sobě jdoucích
          fází. Naopak Agile je iterativní přístup, který se zaměřuje
          na&nbsp;pružnost, spolupráci a&nbsp;rychlé dodávání funkčního
          softwaru. Tato srovnání metodik jsou důležitá pro&nbsp;pochopení
          jejich rozdílů a&nbsp;výběr vhodné metody pro&nbsp;konkrétní projekt.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Backlog</h2>
        <p>
          Backlog je seznam úkolů, požadavků nebo funkcionalit, které mají být
          provedeny v&nbsp;rámci projektu. Jedná se o&nbsp;dynamický seznam,
          který obsahuje prioritizované položky, a&nbsp;slouží jako zdroj
          pro&nbsp;plánování a&nbsp;řízení projektových aktivit. Backlog je
          pravidelně aktualizován a&nbsp;upravován během životního cyklu
          projektu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Bug</h2>
        <p>
          Bug je chyba nebo nedostatek ve&nbsp;funkčnosti softwaru, který
          ovlivňuje jeho správné fungování. Může se jednat o&nbsp;programovou
          chybu, problém s&nbsp;uživatelským rozhraním nebo nepředvídatelné
          chování aplikace. Oprava bugů je důležitá součástí vývoje softwaru
          a&nbsp;slouží k&nbsp;zajištění kvality a&nbsp;spolehlivosti produktu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Dokumentace</h2>
        <p>
          Dokumentace zahrnuje záznamy, instrukce, specifikace a&nbsp;další
          dokumenty, které popisují softwarový produkt, jeho funkcionality,
          architekturu, použití a&nbsp;další relevantní informace. Dobrá
          dokumentace je klíčová pro&nbsp;správné porozumění a&nbsp;správné
          použití softwaru, a&nbsp;také usnadňuje spolupráci mezi týmy
          a&nbsp;přenositelnost projektu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Estimace</h2>
        <p>
          Estimace je proces odhadu času, nákladů nebo zdrojů, které budou
          vyžadovány pro&nbsp;dokončení projektu nebo konkrétního úkolu.
          Estimace pomáhá plánovat a&nbsp;přidělovat zdroje, určit rozpočet
          a&nbsp;termíny, a&nbsp;poskytuje informace pro&nbsp;řízení očekávání
          stakeholderů.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Komunikace</h2>
        <p>
          Komunikace je klíčovou složkou úspěšného projektu. Zahrnuje přenos
          informací, názorů, požadavků a&nbsp;zpětné vazby mezi členy týmu,
          stakeholdery a&nbsp;zákazníkem. Efektivní komunikace pomáhá udržovat
          jasnou a&nbsp;pravidelnou interakci mezi všemi zainteresovanými
          stranami projektu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Milníky</h2>
        <p>
          Milníky jsou klíčové body nebo události v&nbsp;průběhu projektu, které
          označují dosažení určitého milníku nebo splnění důležitého cíle.
          Milníky slouží k&nbsp;rozdělení projektu na&nbsp;menší části
          a&nbsp;umožňují sledovat jeho pokrok a&nbsp;přizpůsobit průběh
          projektu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Nabídka</h2>
        <p>
          Nabídka je komerční návrh, který obsahuje informace o&nbsp;službách,
          produktech, cenách, časovém harmonogramu a&nbsp;dalších klíčových
          aspektech projektu. Je vytvořena v&nbsp;reakci na&nbsp;poptávku nebo
          požadavek zákazníka a&nbsp;slouží jako základní komunikační nástroj
          mezi poskytovatelem a&nbsp;klientem.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Rozpočet (budget)</h2>
        <p>
          Rozpočet je finanční plán, který určuje předpokládané příjmy
          a&nbsp;výdaje pro&nbsp;určitou dobu nebo konkrétní projekt.
          Je&nbsp;základním nástrojem pro&nbsp;správnou alokaci finančních
          prostředků, sledování výdajů a&nbsp;dodržování finančních omezení
          projektu. Správa rozpočtu je důležitou dovedností v&nbsp;projektovém
          řízení, která přispívá k&nbsp;úspěšnému plánování a&nbsp;řízení
          financí projektu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Sprint</h2>
        <p>
          Sprint je časové omezené období, které se používá v&nbsp;rámci
          agilního vývoje softwaru, zejména v&nbsp;metodice Scrum. Jedná se
          o&nbsp;krátké období (obvykle 1&nbsp;až&nbsp;4 týdny), během kterého
          je vyvíjen a&nbsp;testován inkrementální kus softwaru. Sprinty
          umožňují týmu pracovat na&nbsp;konkrétních úkolech, splnit definované
          cíle a&nbsp;průběžně prezentovat výsledky stakeholderům. Sprinty
          podporují rychlé dodávání funkčního softwaru a&nbsp;iterativní přístup
          k&nbsp;vývoji projektu.
        </p>

        <h2 className="ftrs-h2 mt2 mb1">Stakeholdeři</h2>
        <p>
          Stakeholdeři jsou jednotlivci, skupiny nebo organizace, které mají
          zájem na&nbsp;projektu nebo jsou jím ovlivněny. Mohou to být
          zákazníci, vedení organizace, zaměstnanci, dodavatelé, odborníci nebo
          jiné relevantní strany. Stakeholdeři mají různé zájmy, očekávání
          a&nbsp;vliv na&nbsp;projekt, a&nbsp;je důležité správně je
          identifikovat, zapojit do&nbsp;procesu projektového řízení
          a&nbsp;komunikovat s&nbsp;nimi.
        </p>
      </Container>
    </div>

    <Container className="pt-4 pb-4">
      <Bloglist></Bloglist>
    </Container>
  </Layoutcs>
)

export default Blog
